@if (filter.inputType !== 'dropdown' || showSettingsIconForDropdown || hasCompoundFilters) {
  <div>
    <mat-icon
      [matMenuTriggerFor]="filterOptionMenu"
      [svgIcon]="optionMenuIcon"
      *ngIf="!hideSettingsIcon"
      (menuClosed)="onMenuClosed()"
    ></mat-icon>
    <mat-menu class="filter-option-menu" #filterOptionMenu>
      <div class="filter-toggle">
        <mat-button-toggle-group
          *ngIf="!isReports && !hideMenuToggles"
          mat-menu-item
          [formControl]="filterOptionControl"
          hideSingleSelectionIndicator
        >
          <mat-button-toggle
            class="filter-toggle-button"
            *ngFor="let menOpt of menuOptions"
            [value]="menOpt.value"
            [ngClass]="menOpt.cssClass"
          >
            {{ menOpt.labelKey | xTranslate | uppercase }}
          </mat-button-toggle>
        </mat-button-toggle-group>
      </div>

      <ng-container *ngIf="isDateRangeFilter">
        <!-- Options Range-->
        <button [disabled]="disableDateFilter" mat-menu-item *ngFor="let dateFilter of dateFilterOptions">
          <div (click)="setDateRangeFilter(dateFilter)">{{ dateFilter.label | xTranslate }}</div>
        </button>
      </ng-container>

      <ng-container *ngIf="hasCompoundFilters">
        <miq-compound-filter-selection
          [groups]="compoundFilterGroups"
          [defaultSelectedKeys]="compoundFilterDefaultKeys"
          [selectedKeys]="currentCompoundFilterKeys"
          (selectionChange)="onCompoundFilterSelectionChange($event)"
        ></miq-compound-filter-selection>
      </ng-container>
    </mat-menu>
  </div>
}
